module.exports = __webpack_public_path__ + "static/media/gameplay.38c35bcd.mp3";